import { toaster } from '@/components/ui/toaster';
import { writeClipboardText } from '@/libs/clipboard';
import type { ProgramInvitation } from '@fluenceur/types';
import { useTranslation } from 'react-i18next';

/**
 * Copy the invitation's acceptance link and toast the outcome. The server only
 * exposes `invitationLink` while the invitation is still usable (pending or
 * clicked), so the presence of the link is the single visibility rule.
 */
export const useCopyInvitationLink = () => {
  const { t } = useTranslation();

  return async (invitation: ProgramInvitation) => {
    if (!invitation.invitationLink) return;
    if (await writeClipboardText(invitation.invitationLink)) {
      toaster.success({ title: t('invitations.toasts.linkCopied') });
    } else {
      toaster.error({ title: t('invitations.toasts.copyFailed') });
    }
  };
};
